/**
 * Trade-In Cart Logic
 *
 * Handles:
 * 1. Scanning cart items for _trade_in property
 * 2. Recording trade-in agreement in cart attributes
 * 3. Rendering trade-in badges and notices on the cart page
 * 4. Async discount application via fetch('/discount/CODE') — no redirect
 * 5. Cart section DOM refresh via Section Rendering API
 */
(function () {
  "use strict";

  /**
   * Check if any cart items have the _trade_in property
   */
  function checkCartForTradeInItems() {
    return fetch("/cart.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var hasTradeIn = false;
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._trade_in === "true") {
            hasTradeIn = true;
          }
        });
        return { hasTradeIn: hasTradeIn, cart: cart };
      });
  }

  /**
   * Update cart attributes with trade-in agreement status
   */
  function updateCartAttributes(hasTradeIn, cart) {
    var config = window.tradeInConfig;
    var attributes = {};
    if (hasTradeIn) {
      attributes["下取り規約への同意"] = "同意済み";
      attributes["下取りクーポンコード"] = (config && config.discountCode) ? config.discountCode : "";
    } else {
      // カートに trade-in アイテムがない場合、
      // 既に設定済みの属性があればクリアする、なければスキップ
      var currentAttrs = cart && cart.attributes;
      if (!currentAttrs || !currentAttrs["下取り規約への同意"]) {
        return Promise.resolve();
      }
      attributes["下取り規約への同意"] = "";
      attributes["下取りクーポンコード"] = "";
    }

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  /**
   * Display trade-in badge on cart line items that have trade-in
   */
  function renderTradeInBadges() {
    var cartRows = document.querySelectorAll("[data-cart-item]");
    cartRows.forEach(function (row) {
      var propertyItems = row.querySelectorAll("[data-cart-item-property]");
      var hasTradeIn = false;

      propertyItems.forEach(function (prop) {
        var nameEl = prop.querySelector("[data-cart-item-property-name]");
        if (nameEl && nameEl.textContent.trim().indexOf("_trade_in") !== -1) {
          hasTradeIn = true;
        }
      });

      if (hasTradeIn) {
        var titleEl = row.querySelector("[data-cart-item-title]");
        if (titleEl && !titleEl.querySelector(".trade-in-badge")) {
          var badge = document.createElement("span");
          badge.className = "trade-in-badge";
          badge.innerHTML =
            '<svg class="trade-in-badge__icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>' +
            "下取り割引対象";
          titleEl.appendChild(badge);
        }
      }
    });
  }

  /**
   * Add a trade-in notice above the cart footer if trade-in items exist
   */
  function renderTradeInNotice(hasTradeIn) {
    var existingNotice = document.querySelector(".cart-trade-in-notice");
    if (existingNotice) {
      existingNotice.remove();
    }

    if (!hasTradeIn) return;

    var cartFooter = document.querySelector(".cart__footer");
    if (!cartFooter) return;

    var notice = document.createElement("div");
    notice.className = "cart-trade-in-notice";
    notice.innerHTML =
      '<div class="cart-trade-in-notice__text">' +
      ((window.tradeInConfig && window.tradeInConfig.cartNoticeText) ? window.tradeInConfig.cartNoticeText : "下取りオプションが選択された製品があります。割引がチェックアウト時に自動適用されます。") +
      "</div>";

    cartFooter.insertBefore(notice, cartFooter.firstChild);
  }

  /**
   * Apply or clear discount code asynchronously (no page redirect)
   */
  function applyTradeInDiscount(config) {
    if (!config || !config.discountCode) return Promise.resolve();

    if (config.hasTradeInItem && !config.discountApplied) {
      return fetch('/discount/' + encodeURIComponent(config.discountCode), {
        credentials: 'include'
      }).then(function () {
        return refreshCartSection();
      });
    }

    if (!config.hasTradeInItem && config.discountApplied) {
      return fetch('/discount/CLEAR-TRADE-IN', {
        credentials: 'include'
      }).then(function () {
        return refreshCartSection();
      });
    }

    return Promise.resolve();
  }

  /**
   * Refresh cart section HTML using Section Rendering API
   */
  function refreshCartSection() {
    return fetch('/cart?sections=cart-template')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data['cart-template']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data['cart-template'], 'text/html');
          var newCart = doc.querySelector('.cart');
          var currentCart = document.querySelector('.cart');
          if (newCart && currentCart) {
            currentCart.innerHTML = newCart.innerHTML;
            renderTradeInBadges();
          }
        }
      });
  }

  /**
   * Main initialization: scan cart and update UI/attributes
   */
  function initTradeInCart() {
    checkCartForTradeInItems().then(function (result) {
      var hasTradeIn = result.hasTradeIn;

      // Update cart attributes (cart を渡してクリア前に既存属性を確認)
      updateCartAttributes(hasTradeIn, result.cart);

      // Render UI elements
      renderTradeInBadges();
      renderTradeInNotice(hasTradeIn);

      // Async discount application (fallback for cart page)
      var config = window.tradeInConfig;
      if (config) {
        applyTradeInDiscount(config);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTradeInCart);
  } else {
    initTradeInCart();
  }

  // Re-initialize when cart is updated (for AJAX cart)
  window.tradeInCartInit = initTradeInCart;
})();
